// src/features/eventos/domain/eventoUtils.js
export const isBlank = (v) => v == null || v === "";
export const hasText = (s) => typeof s === "string" && s.trim().length > 0;

export const norm = (s) =>
    String(s ?? "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

export const isEmptyMenu = (m) =>
    !hasText(m?.nombre) &&
    !hasText(m?.fecha) &&
    (!Array.isArray(m?.platoIds) || m.platoIds.length === 0);

export const isEmptyActividad = (a) =>
    !hasText(a?.tipo) && !hasText(a?.nombre) && !hasText(a?.fecha);

export const isEmptyParticipacion = (p) => isBlank(p?.personaId);

export const isEmptyCaceria = (c) => {
    const noDoc = !hasText(c?.rutaDocumento);
    const noNombre = !hasText(c?.nombre);
    const noFechaTipo = !hasText(c?.fecha) && !hasText(c?.tipoCaceria);
    const sinPart = !Array.isArray(c?.participaciones) || c.participaciones.length === 0;
    return noDoc && noNombre && noFechaTipo && sinPart;
};

export const isPdf = (url) => typeof url === "string" && url.toLowerCase().endsWith(".pdf");
export const isImage = (url) =>
    typeof url === "string" && /\.(png|jpe?g|webp|gif|avif|bmp|svg)$/i.test(url);
export const isExcel = (url) =>
    typeof url === "string" && /\.(xlsx|xls|csv)$/i.test(url);

export const isDateInRange = (d, start, end) => {
    if (!d || !start || !end) return true;
    return d >= start && d <= end;
};

export const fmtLongDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    const weekday = d.toLocaleDateString("es-ES", { weekday: "long" });
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${weekday} ${day}-${month}-${year}`;
};

export const toSpanishDate = (s) => {
    if (!s) return "";
    const [yyyy, mm, dd] = String(s).split("-");
    if (!yyyy || !mm || !dd) return s;
    return `${dd}-${mm}-${yyyy}`;
};

export const sortPersonasByNombre = (arr) =>
    [...arr].sort((a, b) => {
        const na = `${a.nombre} ${a.apellidos}`.toLowerCase();
        const nb = `${b.nombre} ${b.apellidos}`.toLowerCase();
        return na.localeCompare(nb, "es");
    });
